export default __webpack_public_path__ + "static/media/MH-Gen-AI-Lite.70d37de9.png";